export function isWithinDeltaRange(value, target, deltaPercent) {
    if (target === 0) {
        return Math.abs(value) >= -deltaPercent && Math.abs(value) <= deltaPercent;
    }
    const deltaAmount = Math.abs(target * deltaPercent);
    const lowerBound = target - deltaAmount;
    const upperBound = target + deltaAmount;
    return value >= lowerBound && value <= upperBound;
}
